import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const useCurrentLearnerId = () => {
  const location = useLocation();
  const { id } = useSelector((state: any) => state.account) || "";

  const getCurrentLearnerId = useCallback(() => {
    // Resolve at call time so API requests always use the latest selected learner.
    const sessionLearnerId = sessionStorage.getItem("userId");
    const routeLearnerId = location.state?.user;
    const currentLearnerId = sessionLearnerId || routeLearnerId || id || "";

    if (!currentLearnerId) {
      console.warn("No learner ID found in session storage, route state, or Redux store.");
    };
    
    return currentLearnerId;
  }, [location.state?.user, id]);

  return getCurrentLearnerId;
};

export default useCurrentLearnerId;
